<template>
  <div class="scene-execute-type">
    <div class="blue_border">
      {{ $t("iftttset.moreSettings") }}
    </div>
    <div class="scene-execute-type_container"> 
      <span class="scene-execute-type_label">{{ $t("iftttset.executionMode") }}:</span>
      <el-select v-model="selectedValue" :placeholder="$t('monitor.choose')">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          class="scene-execute-type_select"
        >
          <p class="scene-execute-type_select_title">
            {{ item.label }}
          </p>
          <p class="scene-execute-type_select_desc">
            {{ item.info }}
          </p>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedValue:this.value,
      options: [{
        value: 0,
        label: `${this.$t('iftttset.local')} (${this.$t('iftttset.recommendation')})`,
        info: this.$t('iftttset.tip1'),
      }, {
        value: 1,
        label: this.$t('iftttset.cloud'),
        info: this.$t('iftttset.tip2'),
      }]
    }
  },

  computed: {
   
  },
  watch: {
    selectedValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.selectedValue = val;
    }
  },
  created() {
    console.log('iftttExecuteType', this.value)
  },

  destroyed() {
    this.$emit('input', 0);
  },

  mounted() {},

  methods: {
   
  },
};
</script>

<style lang="scss" scoped>
.scene-execute-type {
  margin-bottom: 90px;

  &_container {
    margin: 50px 80px;
  }

  &_label {
    margin-right: 14px;
    font-weight: 600;
  }
}
</style>
<style lang="scss">
.scene-execute-type_select {
  height: auto !important;
  padding-bottom: 8px;
  margin: 0 10px;

    &:not(:last-child) {
      border-bottom: 1px solid #e8e8e8;
    }
  &_desc {
    font-size: 12px;
    line-height: 14px;
    color: #999;
    font-weight: 300;
  }
}
</style>